import { DEFAULT_LANGUAGE_CODE } from '@/constants/languages';
import en from '@/constants/locales/en.json';
import es from '@/constants/locales/es.json';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

export async function initializeI18n() {
  if (i18next.isInitialized) return i18next;
  // eslint-disable-next-line import/no-named-as-default-member
  await i18next.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: DEFAULT_LANGUAGE_CODE,
    fallbackLng: DEFAULT_LANGUAGE_CODE,
    interpolation: {
      escapeValue: false, // React protects from XSS
    },
  });
  return i18next;
}
